import React, { useState, useRef } from 'react'
import Button from './index'
import {
    Typography,
    Box,
    Backdrop,
    styled,
    MenuItem,
    useTheme,
} from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { Dropdown } from 'packages/eid-ui'

const StyledBackdrop = styled(Backdrop)(() => ({
    zIndex: '1201',
}))

const StyledMenuItem = styled(MenuItem)({
    height: '30px',
})

const DropdownOptionsButton = ({
    children,
    disabled,
    onClick,
    label,
    options = [],
    parentStyle = {},
    showPrefixIcon = false,
    showEndIcon = true,
    showBackdrop = true,
    ...rest
}) => {
    const theme = useTheme()
    const [open, setOpen] = useState(false)
    const closeMenu = () => {
        setOpen((prev) => !prev)
    }
    const anchorRef = useRef(null)

    const styles = {
        normal: {
            width: '100%',
            height: '100%',
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
            border: '0px',
            padding: '0px',
            zIndex: open ? '1202' : '0',
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
                cursor: 'pointer',
            },
            '& .MuiButton-endIcon': {
                borderLeft: '1px solid rgba(255, 255, 255, 0.25)',
                height: '100%',
                marginLeft: '0px',
                marginRight: '0px',
                alignItems: 'center',
            },
            '& .MuiButton-label': {
                height: '100%',
            },
        },
        disabled: {
            backgroundColor: '#fff',
            border: 'solid 1px #ebe6e8',
            color: '#3f3f55 !important',
        },
        labelContainer: {
            width: '100%',
            padding: '0px 0.9rem',
        },
        label: {
            fontSize: '11px',
            lineHeight: 'normal',
        },
        icon: {
            borderLeft: '1px solid rgba(255, 255, 255, 0.25)',
            display: 'flex',
            alignItems: 'center',
            width: '20%',
        },
        dropdownAnchor: {
            position: 'absolute',
            top: parentStyle.height || '10px',
            left: '28px',
        },
    }

    return (
        <>
            <Button
                style={{ ...styles.normal, ...parentStyle }}
                disabled={disabled}
                disabledStyles={styles.disabled}
                startIcon={
                    showPrefixIcon && (
                        <Box
                            style={{
                                position: 'relative',
                                left: '15px',
                            }}
                        >
                            <Icon
                                name="CheckWithWhiteCircle"
                                width="20px"
                                fill={theme.palette.common.white}
                                direction="down"
                                size="large"
                                style={{
                                    height: '20px !important',
                                }}
                            />
                        </Box>
                    )
                }
                onClick={!children ? onClick : null}
                endIcon={
                    !disabled &&
                    options.length > 0 &&
                    showEndIcon && (
                        <Box
                            onClick={() => {
                                setOpen((prev) => !prev)
                            }}
                            style={{
                                position: 'relative',
                                display: 'flex',
                                height: '100%',
                                alignItems: 'center',
                                backgroundColor: theme.palette.primary.main,
                                cursor: 'pointer',
                                borderRadius: '0px 4px 4px 0px',
                            }}
                        >
                            <Icon
                                name="ArrowSmall"
                                fill={theme.palette.common.white}
                                width="20px"
                                height={showPrefixIcon ? '8px' : '5px'}
                                direction="down"
                            />
                            <span
                                ref={anchorRef}
                                style={styles.dropdownAnchor}
                            />
                        </Box>
                    )
                }
                {...rest}
            >
                {!children ? (
                    <>
                        <Box style={styles.labelContainer}>
                            <Typography style={styles.label}>
                                {label}
                            </Typography>
                        </Box>
                    </>
                ) : (
                    children
                )}
            </Button>

            {options.length > 0 && (
                <>
                    <StyledBackdrop
                        sx={{ color: '#fff' }}
                        open={showBackdrop && open}
                        onClick={closeMenu}
                    />
                    <Dropdown
                        anchorEl={anchorRef.current}
                        showCone={true}
                        keepMounted
                        open={open}
                        onClose={closeMenu}
                        listStyles={{
                            paddingBottom: '0px',
                            '& > ul': {
                                paddingBottom: '7px',
                                paddingTop: '0px',
                            },
                        }}
                        iconPosition={{
                            top: '-5px',
                            right: '0px',
                        }}
                        width="auto"
                        disableScrollLock={false}
                        rootStyles={rest?.rootStyles || {}}
                    >
                        {options.map((op, i) => {
                            return (
                                <StyledMenuItem
                                    onClick={() => {
                                        op.onClick()
                                        closeMenu()
                                    }}
                                    key={i}
                                >
                                    {op.label}
                                </StyledMenuItem>
                            )
                        })}
                    </Dropdown>
                </>
            )}
        </>
    )
}

export default DropdownOptionsButton
